import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MensalCenario } from 'types/Relatorios/Mensal';

export interface MensalDataAnalisada {
  mes: number;
  ano: number;
  dia: number;
}

export interface RelatoriosMensalState {
  mes: number;
  ano: number;
  dia: number;
  cenario: MensalCenario;
}

const now = new Date();
const initialState: RelatoriosMensalState = {
  mes: now.getMonth() + 1,
  ano: now.getFullYear(),
  dia: now.getDate(),
  cenario: 'preliminar',
};

const relatoriosMensalSlice = createSlice({
  name: 'relatoriosMensal',
  initialState,
  reducers: {
    setDataAnalisada: (state, action: PayloadAction<MensalDataAnalisada>) => {
      state.mes = action.payload.mes;
      state.ano = action.payload.ano;
      state.dia = action.payload.dia;
    },
    setCenario: (state, action: PayloadAction<MensalCenario>) => {
      state.cenario = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setDataAnalisada, setCenario, reset,
} = relatoriosMensalSlice.actions;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fatiaMensal = (state: any): RelatoriosMensalState => state.relatoriosMensal;
/**
 * Memorizado: devolve o mesmo objeto enquanto a data não muda. O `useSelector` compara por
 * referência, e um objeto novo a cada chamada desenharia de novo, a cada ação do Redux (RTK Query,
 * polling), toda tela que lê a data.
 */
export const selectMensalDataAnalisada = createSelector(
  [
    (state: unknown) => fatiaMensal(state).mes,
    (state: unknown) => fatiaMensal(state).ano,
    (state: unknown) => fatiaMensal(state).dia,
  ],
  (mes, ano, dia): MensalDataAnalisada => ({ mes, ano, dia }),
);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectMensalCenario = (state: any): MensalCenario => (
  state.relatoriosMensal.cenario
);

export default relatoriosMensalSlice.reducer;
